import React, { useEffect, useState } from 'react'
import { useThemeContext } from '../../../Context/ThemeContext';
import { useTranslation } from 'react-i18next';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import { Box, Button, InputAdornment, MenuItem, Select, TablePagination, TextField } from '@mui/material';
import './ServiceRequest.css'
import Card1 from '../../../assets/Cards/Card1.webp'
import Card2 from '../../../assets/Cards/Card4.webp'
import Card3 from '../../../assets/Cards/Card2.webp'
import CardGroup from '../../../Components/Common/CardGroup';
import { deleteServiceRequest, getServiceRequestCardsCount, getServiceRequests, getUserDetails } from '../../../Services/authService';
import SearchIcon from "@mui/icons-material/Search";
import { DARKCOLORS, LIGHTCOLORS, ROUTES } from '../../../Utils/constants';
import DeleteConfirmationPopup from '../../../Components/Common/DeleteConfirmationPopup';
import SuccessNotification from '../../../Components/Common/SuccessNotification';
import { DropDownIcon } from '../../../Components/Layouts/CustomIcons';
import LoadingAnimation from '../../../Components/Common/LoadingAnimation';
import { useLocation, useNavigate } from 'react-router-dom';
import ServiceRequestModal from './ServiceRequestModal';
import TableComponent from '../../Manage/MembershipCards/TableComponent';

function ServiceRequest() {
  const location = useLocation();
  const { mode } = useThemeContext();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const containerBackground = mode === 'dark' ? DARKCOLORS.BackgroundCard : LIGHTCOLORS.BackgroundCard
  const searchBackground = mode === 'dark' ? DARKCOLORS.GreyScale10 : LIGHTCOLORS.GreyScale10;
  const borderColor1 = mode === 'dark' ? DARKCOLORS.GreyScale40 : LIGHTCOLORS.GreyScale40;
  const dropCircle = mode === 'dark' ? DARKCOLORS.GreyScale50 : LIGHTCOLORS.GreyScale50;
  const dropIcon = mode === 'dark' ? DARKCOLORS.GreyScale80 : LIGHTCOLORS.GreyScale80;

  const [cardData, setCardData] = useState([]);
  const [userData, setUserData] = React.useState({});

  const columns = [
    { field: "reportedDate", label: t("membershipCards.Date") },
    { field: "location", label: t("serviceRequest.location") },
    { field: "machineNumber", label: t("serviceRequest.machineNumber") },
    { field: "issueCategory", label: t("serviceRequest.issueCategory") },
    { field: "issueType", label: t("serviceRequest.issueType") },
    { field: "description", label: t("serviceRequest.description") },
    // { field: "assignedTo", label: t("serviceRequest.assignedTo"), align: "center" },
    { field: "status", label: t("membershipCards.status") },
    // { field: "comments", label: t("serviceRequest.comments"), align: "center" },
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [modalOpenedByNotification, setModalOpenedByNotification] = useState(false);
const scroll1 = mode === 'light' ? LIGHTCOLORS.BodyDarkBackground : DARKCOLORS.BodyLightBackground;
  const scroll = mode === 'light' ? LIGHTCOLORS.GreyScale40 : DARKCOLORS.GreyScale40;

  useEffect(() => {
    if (location.state?.referenceId && rows.length > 0 && !modalOpenedByNotification) {
      const selectedCard = rows.find(card => card.id === location.state?.referenceId);
      if (selectedCard) {
        setSelectedCard(selectedCard);
        setIsModalOpen(true);
        setModalOpenedByNotification(true); // Prevents re-triggering
      }
    }
  }, [location.state?.referenceId, rows]);


  const fetchCurrentUser = async () => {
    try {
      setLoading(true);
      const data = await getUserDetails();
      setUserData(data);
    } catch (error) {
      console.error(t("navbar.errorFetchingUserData"), error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCurrentUser();
  }, []);

  const hasFranchiseId = Number(userData?.franchiseId) !== 1;

  useEffect(() => {
    const fetchCardsCount = async () => {
      const cardsCount = await getServiceRequestCardsCount();
      const updatedCardData = [
        { value: cardsCount.open, label: t('serviceRequest.open'), background: Card1 },
        { value: cardsCount.inProgress, label: t('serviceRequest.inprogress'), background: Card2 },
        { value: cardsCount.completed, label: t('serviceRequest.completed'), background: Card3 },
      ];

      setCardData(updatedCardData);
    };

    fetchCardsCount();
  }, [i18n.language, t]);

  const handleOpenModal = () => {
    setSelectedCard(null)
    setIsModalOpen(true)
  };

  const handleCloseModal = () => setIsModalOpen(false);

  const fetchServiceRequests = async () => {
    try {
      const data = await getServiceRequests(page, rowsPerPage, searchTerm, statusFilter);
      setRows(data.content);
      setTotalRows(data.totalElements);
    } catch (error) {
      console.error(t("serviceRequest.fetchServiceRequestsError"), error);
    }
  };

  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setPage(0); // searching always shows matches from the first page
  };
  const handleStatusFilterChange = (e) => {
    setStatusFilter(e.target.value);
    setPage(0);
  };

  useEffect(() => {
    fetchServiceRequests();
  }, [page, rowsPerPage, searchTerm, statusFilter]);

  const handleEditClick = (row) => {
    if (!hasFranchiseId) {
      navigate(ROUTES.COMPLAINTS, { state: { complaintData: row } });
      // console.log("Clicked row:", row); // ✅ Add this
    } else {
      setSelectedCard(row);
      setIsModalOpen(true);
    }
  };

  const handleRowClick = (row) => {
    if (!hasFranchiseId) {
      navigate(ROUTES.COMPLAINTS, { state: { complaintData: row } });
      // console.log("Clicked row:", row); // ✅ Add this
    }
  };

  const handleDeleteClick = (row) => {
    setSelectedRow(row);
    setIsDeletePopupOpen(true);
  };

  const handleCloseDeletePopup = () => {
    setIsDeletePopupOpen(false);
    setSelectedRow(null);
  };

  const handleConfirmDelete = async () => {
    if (!selectedRow) return;

    try {
      setLoading(true)
      await deleteServiceRequest(selectedRow.id); // Call the delete API
      setSuccessMessage(` ${t('serviceRequest.successMessage1')} ${t('serviceRequest.successMessage2')}`);
      setNotificationOpen(true); // Show success notification
      await fetchServiceRequests(); // Refresh the table data
      handleCloseDeletePopup(); // Close the delete confirmation popup
    } catch (error) {
      setErrorMessage(t("serviceRequest.deleteServiceRequestError"));
    } finally {
      setLoading(false)
    }
  };

  const handleCloseNotification = () => {
    setNotificationOpen(false);
    setSuccessMessage('');
  };

  return (
    <div className='dashboard-container-overview'>
      {loading && <LoadingAnimation />}
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <h2 className='membership-text-heading'>{t('serviceRequest.serviceRequest')}</h2>
        {hasFranchiseId && (
          <Button id='service-request-button' className='export-sales-btn ' onClick={handleOpenModal} endIcon={<AddCircleOutlineOutlinedIcon style={{ marginTop: "1px" }} />}>
            {t('serviceRequest.requestService')}
          </Button>
        )}
      </Box>

      <CardGroup cardData={cardData} />

      <Box style={{ background: containerBackground, borderRadius: "12px" }}>
        <Box className="membership-list-icon-section" sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: 2 }}>
          <TextField
            className='membership-search-bar'
            placeholder={t("serviceRequest.searchByLocation")}
            value={searchTerm}
            onChange={handleSearchChange}
            style={{ borderRadius: "24px", background: searchBackground, width: "calc(12rem + 12vw)" }}
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ fontSize: "20px" }} />
                </InputAdornment>
              ),
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  border: "none", // Removes the border from the outline
                },
              },
            }}
          />

          <Box className='membership-btn-section' sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            {/* Sort */}
            <Box className='sort-btn maintainencesort-btn' sx={{ display: "flex", gap: 2 }}>
              <Select
                value={statusFilter}
                onChange={handleStatusFilterChange}
                displayEmpty
                size="small"
                IconComponent={(props) => (
                  <DropDownIcon color1={dropCircle} color2={dropIcon} {...props} />
                )} // Use the custom DropDownIcon component
                sx={{
                  borderRadius: "24px",
                  border: `0px solid ${borderColor1}`,
                  textAlign: "center",
                  paddingRight: "12px",
                  "& .MuiSelect-select": {
                    padding: "9px 20px 9px 20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: `0.5px solid ${borderColor1}`,
                  },
                  '@media (max-width: 470px)': {
                    fontSize: '13px',
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      borderRadius: "16px",
                      border: `0px solid ${borderColor1}`,
                      boxShadow: "none",
                      backgroundColor: containerBackground,
                      padding: "10px",
                      marginTop: "10px",
                    },
                  },
                }}
                renderValue={(selected) => {
                  if (selected === "") {
                    return (
                      <p className='sort-filter-text'>{t("membershipCards.filter")}</p>
                    );// Show "Sort" as placeholder when no value selected
                  }
                  return selected;
                }}
              >
                <MenuItem className='menu-item-sec' value="">{t("membershipCards.all")}</MenuItem>
                <MenuItem className='menu-item-sec' value="Open">{t("serviceRequest.open")}</MenuItem>
                <MenuItem className='menu-item-sec' value="In Progress">{t("serviceRequest.inprogress")}</MenuItem>
                <MenuItem className='menu-item-sec' value="Completed">{t("serviceRequest.completed")}</MenuItem>
              </Select>
            </Box>
          </Box>
        </Box>
        {loading ? (
          <p>{t('vendingMachines.Loading')}</p>
        ) : (
          <>
            <TableComponent
              rows={rows || []}
              columns={columns || []}
              onEdit={handleEditClick}
              onRowClick={handleRowClick}
              onDelete={handleDeleteClick}
              selectedRows={selectedRows || []}
              enableRowClick={true}
              showDelete
            />
            <TablePagination
              component="div"
              count={totalRows}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage={t('membershipCards.RowsPerPage', 'Rows Per Page')}
              sx={{
                display: 'flex',
                justifyContent: 'center', // Center the pagination controls
                alignItems: 'center',
                overflowX: 'auto',
                // Same custom scrollbar as the table container
                '&::-webkit-scrollbar': {
                  width: '10px !important',
                  height: '10px !important',
                },
                '&::-webkit-scrollbar-track': {
                  backgroundColor: scroll1,
                  borderRadius: '10px',
                  border: `1px solid ${scroll}`,
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: scroll,
                  borderRadius: '10px',
                  border: '3px solid transparent',
                  backgroundClip: 'padding-box',
                  '&:hover': {
                    backgroundColor: scroll,
                  },
  //                   const scroll1 = mode === 'light' ? LIGHTCOLORS.BodyDarkBackground : DARKCOLORS.BodyLightBackground;
  // const scroll = mode === 'light' ? LIGHTCOLORS.GreyScale40 : DARKCOLORS.GreyScale40;

                },
              }}
            />
          </>
        )}
      </Box>

      {/* Modal Popup */}
      <ServiceRequestModal open={isModalOpen} onClose={handleCloseModal} selectedCard={selectedCard} fetchServiceRequests={fetchServiceRequests} />

      {/* Delete Confirmation Popup */}
      <DeleteConfirmationPopup
        open={isDeletePopupOpen}
        onClose={handleCloseDeletePopup}
        heading={t('serviceRequest.deleteConfirmHeading')}
        message={t('serviceRequest.deleteConfirmMessage')}
        onConfirm={handleConfirmDelete}
        itemName={`(${selectedRow?.id})`}
        errorMessage={errorMessage}
      />

      {/* Success Notification */}
      <SuccessNotification
        open={notificationOpen}
        message={successMessage}
        onClose={handleCloseNotification}
      />
    </div>
  )
}

export default ServiceRequest